export const LOGIN ="LOGIN"
export const LOGOUT ="LOGOUT"
export const NAME ="NAME"
export const ERROR = "ERROR"
export const LANGUAGE = "LANGUAGE"
export const SEND_PASSWORD_RESET_EMAIL = "SEND_PASSWORD_RESET_EMAIL";
export const PASSWORD_RESET_EMAIL_SENT = 'PASSWORD_RESET_EMAIL_SENT';
export const PASSWORD_RESET_EMAIL_ERROR = 'PASSWORD_RESET_EMAIL_ERROR';
export const UPDATE_USER = 'UPDATE_USER';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const REGISTER_USER = 'REGISTER_USER';
export const LOADING = 'LOADING';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const FETCH_SEMESTER_REQUEST = 'FETCH_SEMESTER_REQUEST';
export const FETCH_SEMESTER_SUCCESS = 'FETCH_SEMESTER_SUCCESS';
export const FETCH_SEMESTER_FAILURE = 'FETCH_SEMESTER_FAILURE';
export const SET_CURRENT_SEMESTER = 'SET_CURRENT_SEMESTER';
export const CLEAR_SEMESTER = 'CLEAR_SEMESTER';

export const FETCH_PERMISSIONS_REQUEST = 'FETCH_PERMISSIONS_REQUEST';
export const FETCH_PERMISSIONS_SUCCESS = 'FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILURE = 'FETCH_PERMISSIONS_FAILURE';
export const UPDATE_PERMISSION = 'UPDATE_PERMISSION';
